import React, { useState } from 'react';
import { Clock, ChevronDown, ChevronUp, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../mock';
import { PageSEO } from './SEO';

export const Services = () => {
  const [expandedCards, setExpandedCards] = useState({});
  
  // Lien WhatsApp standardisé
  const WHATSAPP_BASE = 'https://wa.me/33640486009?text=';

  const toggleCard = (cardId) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  const openWhatsAppWithService = (serviceName) => {
    const message = `Bonjour, je voudrais réserver : ${serviceName} 💅`;
    const encodedMessage = encodeURIComponent(message).replace(/%20/g, '%20');
    window.open(`${WHATSAPP_BASE}${encodedMessage}`, '_blank');
  };

  return (
    <section id="services" className="py-16 md:py-20" style={{ backgroundColor: '#FAF6F4' }}>
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-3 md:mb-4">
            Services & Tarifs
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-xl mx-auto">
            Toutes mes prestations à domicile
          </p>
        </div>

        {/* Services en colonnes sur mobile */}
        <div className="max-w-4xl mx-auto space-y-6 md:space-y-8">
          {services.map((category) => (
            <div key={category.id} className="space-y-3">
              {/* Titre catégorie */}
              <h3 className="text-xl md:text-2xl font-bold px-2" style={{ color: '#D1477A' }}>
                {category.category}
              </h3>
              
              {/* Cards des services */}
              <div className="space-y-3">
                {category.items.map((item) => {
                  const cardId = item.id;
                  const isExpanded = expandedCards[cardId];
                  
                  return (
                    <div
                      key={cardId}
                      className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                      style={{ borderColor: '#E8B4D1', borderWidth: '1px' }}
                    >
                      {/* En-tête de la card - Toujours visible */}
                      <button
                        onClick={() => toggleCard(cardId)}
                        className="w-full p-4 md:p-5 flex items-center justify-between text-left"
                      >
                        <div className="flex-1 pr-4">
                          <h4 className="font-semibold text-gray-800 text-base md:text-lg">
                            {item.name}
                          </h4>
                          <div className="flex items-center gap-2 mt-1 text-sm text-gray-500">
                            <Clock size={14} />
                            <span>{item.duration}</span>
                          </div>
                        </div>
                        <div className="flex items-center gap-3">
                          <span className="text-xl md:text-2xl font-bold" style={{ color: '#D1477A' }}>
                            {item.price}
                          </span>
                          {isExpanded ? (
                            <ChevronUp className="text-gray-400" size={24} />
                          ) : (
                            <ChevronDown className="text-gray-400" size={24} />
                          )}
                        </div>
                      </button>

                      {/* Contenu déplié */}
                      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${
                        isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                      }`}>
                        <div className="px-4 pb-4 md:px-5 md:pb-5 space-y-4">
                          {/* Description optionnelle */}
                          {item.description && (
                            <p className="text-gray-600 text-sm">
                              {item.description}
                            </p>
                          )}
                          
                          {/* Infos supplémentaires */}
                          <div className="flex flex-wrap gap-2 text-sm">
                            <span className="px-3 py-1 bg-white rounded-full text-gray-600 border border-gray-200">
                              Durée: {item.duration}
                            </span>
                            <span className="px-3 py-1 bg-white rounded-full text-gray-600 border border-gray-200">
                              À domicile
                            </span>
                          </div>

                          {/* Bouton réservation */}
                          <Button
                            onClick={() => openWhatsAppWithService(item.name)}
                            className="w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-xl text-base font-semibold gap-2 min-h-[48px]"
                          >
                            <MessageCircle size={20} />
                            Réserver cette prestation
                          </Button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Info zone de déplacement */}
        <div className="mt-10 md:mt-12 max-w-2xl mx-auto">
          <div className="bg-white p-4 md:p-6 rounded-2xl" style={{ borderLeftWidth: '4px', borderLeftColor: '#D1477A' }}>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              <span className="font-semibold" style={{ color: '#D1477A' }}>📍 Zones desservies :</span>{' '}
              Ravine des Cabris, Saint-Pierre, Le Tampon, Saint-Louis...
            </p>
            <p className="text-gray-600 text-sm mt-2">
              Hors zone : supplément de 10€ (dégressif selon prestation)
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
